import React from 'react';
import './isi.scss';

function IsiButton({ isOpen, setIsOpen, origin }) {
  return (
    <div className={isOpen ? 'isi__button isi__button--open' : 'isi__button'}>
      <button
        className="isi__button-button"
        onClick={() => {
          origin === 'modal' ? setIsOpen(false) : setIsOpen(true);
        }}
      >
        {isOpen ? 'Close' : 'View'} Important Safety Information
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 10 8"
          fill="none"
          className={isOpen ? 'isi__button__arrow isi__button__arrow--open' : 'isi__button__arrow'}
        >
          <path fillRule="evenodd" clipRule="evenodd" d="M5 8L0 0L10 0L5 8Z" fill="#A9A9A9" />
        </svg>
      </button>
    </div>
  );
}

export default IsiButton;
